import { memo } from "react"

const IconClose = () => {
  return (
    <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.73563 7.88174C9.08719 8.22353 9.08719 8.77725 8.73563 9.11904C8.56125 9.28994 8.33062 9.37471 8.1 9.37471C7.86937 9.37471 7.63931 9.28926 7.46381 9.11836L4.5 6.23838L1.53647 9.11767C1.36069 9.28994 1.13034 9.37471 0.9 9.37471C0.669656 9.37471 0.439594 9.28994 0.263672 9.11767C-0.0878906 8.77588 -0.0878906 8.22217 0.263672 7.88037L3.22805 4.99834L0.263672 2.11768C-0.0878906 1.77588 -0.0878906 1.22217 0.263672 0.880371C0.615234 0.538574 1.18477 0.538574 1.53633 0.880371L4.5 3.76377L7.46437 0.881738C7.81594 0.539941 8.38547 0.539941 8.73703 0.881738C9.08859 1.22354 9.08859 1.77725 8.73703 2.11904L5.77266 5.00107L8.73563 7.88174Z"
        fill="#002C98"
      />
    </svg>
  )
}

export default memo(IconClose)
